import React from 'react'
import { Arrow } from 'components/shared/Arrow/Arrow'
import { Box } from 'components/layout/Box/Box'
import { ScoreChip } from 'components/shared/ScoreChip/ScoreChip'
import { useTooltip } from 'hooks'
import * as R from 'ramda'
import { TetherPortal } from 'components/shared/TetherPortal/TetherPortal'
import styles from './TraitScoreCard.module.scss'

export const TraitScoreCard = ({ label, score, subscores, theme }) => {
  const {
    state: {
      arrowRef,
      arrowStyle,
      floating,
      floatingStyle,
      reference,
      hasArrow,
      isToggled,
    },
    handlers: {
      handleBlur,
      handleFocus,
      handleMouseEnter,
      handleMouseLeave,
      handleTouchEnd,
      handleTouchStart,
    },
  } = useTooltip({ initialPlacement: 'top-start' })

  return (
    <>
      <div
        {...{
          ref: reference,
          onBlur: handleBlur,
          onFocus: handleFocus,
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          onTouchStart: handleTouchStart,
          onTouchEnd: handleTouchEnd,
        }}
      >
        <Box align="center" className={styles.card} justify="space-between">
          <p className={styles.label}>{label}</p>
          <ScoreChip size="small" {...{ score, theme }} />
        </Box>
      </div>

      <TetherPortal isOpen={isToggled && !R.isEmpty(subscores)}>
        <Box
          align="center"
          className={styles.message}
          justify="center"
          ref={floating}
          // TODO(a11y): was role="status", which <Box> silently drops. Restore as
          // ariaRole once the DOM change can be verified in the UI.
          style={floatingStyle}
        >
          {hasArrow && (
            <Arrow
              ref={arrowRef}
              size="small"
              style={arrowStyle}
              theme="bright"
            />
          )}
          <Box
            align="center"
            className={styles.content}
            direction="column"
            justify="center"
            // TODO(a11y): was role="tooltip", which <Box> silently drops. Restore as
            // ariaRole once the DOM change can be verified in the UI.
          >
            {R.map(trait => {
              return (
                <Box
                  className={styles.trait}
                  key={trait.label}
                  justify="space-between"
                >
                  <div>{trait.label}</div>
                  <div className={styles.traitScore}>{trait.score}</div>
                </Box>
              )
            }, subscores)}
          </Box>
        </Box>
      </TetherPortal>
    </>
  )
}
